import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "catalogo-overlay"
}
const _hoisted_2 = { class: "catalogo-modal" }
const _hoisted_3 = { class: "catalogo-header" }
const _hoisted_4 = { class: "catalogo-body" }
const _hoisted_5 = { class: "catalogo-grid" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "tipo-nombre" }
const _hoisted_8 = { class: "tipo-desc" }
const _hoisted_9 = { class: "catalogo-lista-factores" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "catalogo-footer" }
const _hoisted_12 = ["disabled"]

import { ref, computed } from 'vue'
import { useGestionResultadosAutoevaluacion } from '@/store/GestionResultadosAutoevaluacion'


export default /*@__PURE__*/_defineComponent({
  __name: 'CatalogoBloquesModal',
  props: {
    visible: { type: Boolean }
  },
  emits: ["cerrar", "insertar"],
  setup(__props: any, { emit: __emit }) {

/**
 * Catálogo de bloques reutilizables del informe.
 *
 * Componente de presentación. Recibe sus datos por props o del store del módulo.
 */


const emit = __emit

const store = useGestionResultadosAutoevaluacion()

function sortByOrdinal(a: string | null | undefined, b: string | null | undefined): number {
  const ap = (a ?? '').split('.').map(n => parseInt(n, 10) || 0)
  const bp = (b ?? '').split('.').map(n => parseInt(n, 10) || 0)
  for (let i = 0; i < Math.max(ap.length, bp.length); i++) {
    const d = (ap[i] ?? 0) - (bp[i] ?? 0)
    if (d !== 0) return d
  }
  return 0
}

const factores = computed(() =>
  [...(store.resultados?.factores ?? [])].sort((a, b) => sortByOrdinal(a.ordinal, b.ordinal))
)

function fmtOrdinal(ordinal: string | null | undefined): string {
  if (!ordinal) return ''
  const parts = ordinal.split('.')
  return parts.length <= 1 ? ordinal : parts.slice(1).join('.')
}

const tipos = [
  { id: 'TEXTO',            nombre: 'Caja de texto',         descripcion: 'Párrafo de texto libre con formato (negrita, listas, títulos…). Puede ir antes o después de tablas.' },
  { id: 'KPIS_RESUMEN',     nombre: 'KPIs de resumen',       descripcion: 'Cuadro de métricas clave: total indicadores, promedio y nivel general.' },
  { id: 'TABLA_GENERAL',    nombre: 'Tabla general',         descripcion: 'Tabla completa con todos los factores, características, aspectos y valoraciones.' },
  { id: 'TABLA_SEMAFORO',   nombre: 'Tabla semáforo',        descripcion: 'Vista de clasificación por fortalezas, debilidades y aspectos muy débiles.' },
  { id: 'TABLA_ESTRUCTURA', nombre: 'Estructura jerárquica', descripcion: 'Tabla que muestra la jerarquía completa del modelo con valoraciones.' },
  { id: 'GRAFICOS_TODOS',   nombre: 'Todos los gráficos',    descripcion: 'Gráficos de barras de todos los factores del modelo.' },
  { id: 'GRAFICO_FACTOR',   nombre: 'Gráfico por factor',    descripcion: 'Gráfico de barras de un factor específico del modelo.' },
  { id: 'COMPARATIVO',      nombre: 'Comparativo',           descripcion: 'Vista comparativa de calificaciones entre distintos procesos de autoevaluación.' },
  { id: 'IMAGEN',           nombre: 'Imagen',                descripcion: 'Inserta una imagen desde URL. Configurable en tamaño y pie de imagen.' },
  { id: 'TABLA_CUSTOM',     nombre: 'Tabla personalizada',   descripcion: 'Crea una tabla libre con columnas y filas propias, con opción de importar datos del modelo.' },
]

const paso = ref<1 | 2>(1)
const tipoSel = ref<string | null>(null)
const factorSel = ref<number | null>(null)

function seleccionarTipo(id: string) {
  tipoSel.value = id
  if (id === 'GRAFICO_FACTOR') {
    paso.value = 2
    factorSel.value = null
  }
}

const puedeInsertar = computed(() => {
  if (!tipoSel.value) return false
  if (tipoSel.value === 'GRAFICO_FACTOR') return factorSel.value !== null
  return true
})

function confirmar() {
  if (!tipoSel.value || !puedeInsertar.value) return
  const bloque: { tipo: string; params?: Record<string, any> } = { tipo: tipoSel.value }
  if (tipoSel.value === 'GRAFICO_FACTOR' && factorSel.value !== null) {
    bloque.params = { id_componente: factorSel.value }
  }
  emit('insertar', bloque)
  tipoSel.value = null
  factorSel.value = null
  paso.value = 1
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (_ctx.visible)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _cache[3] || (_cache[3] = _createElementVNode("h3", null, "Insertar bloque de datos", -1)),
              _createElementVNode("button", {
                class: "btn-cerrar",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('cerrar')))
              }, "✕")
            ]),
            _createElementVNode("div", _hoisted_4, [
              (paso.value === 1)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "catalogo-desc" }, "Seleccione el tipo de bloque que desea insertar en la sección actual.", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tipos, (t) => {
                        return _createElementVNode("button", {
                          key: t.id,
                          class: _normalizeClass(["tipo-card", { seleccionado: tipoSel.value === t.id }]),
                          onClick: ($event: any) => (seleccionarTipo(t.id))
                        }, [
                          _createElementVNode("span", _hoisted_7, _toDisplayString(t.nombre), 1),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(t.descripcion), 1)
                        ], 10, _hoisted_6)
                      }), 64))
                    ])
                  ], 64))
                : (paso.value === 2)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("button", {
                        class: "btn-back",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (paso.value = 1))
                      }, "← Volver"),
                      _cache[5] || (_cache[5] = _createElementVNode("p", { class: "catalogo-desc" }, "Seleccione el factor para el gráfico.", -1)),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(factores.value, (f) => {
                          return (_openBlock(), _createElementBlock("button", {
                            key: f.id_componente,
                            class: _normalizeClass(["factor-item", { seleccionado: factorSel.value === f.id_componente }]),
                            onClick: ($event: any) => (factorSel.value = f.id_componente)
                          }, [
                            _createElementVNode("b", null, _toDisplayString(fmtOrdinal(f.ordinal)), 1),
                            _createTextVNode(" " + _toDisplayString(f.nombre), 1)
                          ], 10, _hoisted_10))
                        }), 128))
                      ])
                    ], 64))
                  : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("button", {
                class: "btn salir",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('cerrar')))
              }, "Cancelar"),
              _createElementVNode("button", {
                class: "btn guardar",
                disabled: !puedeInsertar.value,
                onClick: confirmar
              }, "Insertar", 8, _hoisted_12)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})